import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';

import { LocalizationContext } from '../../../../../AppContext';
import Toolbar from './PresidentsTableToolbar';
import ColumnDefinition from './PresidentsTableColumnDefinition';
import RowsMapper from './PresidentsTableRowsMapper';
import localization from './PresidentsTable.local';

export default function PresidentsTable({
  parties,
  presidents,
  onRowClick,
  onAddClick,
  onTypesClick,
  onPartiesClick,
}) {
  const local = localization[useContext(LocalizationContext)];
  const [rows, setRows] = useState();
  const [columns, setColumns] = useState();

  useEffect(() => setColumns(ColumnDefinition(local)), []);
  useEffect(() => setRows(RowsMapper(local, parties, presidents)), [parties, presidents]);

  return (
    <Paper sx={{ height: '100%' }}>
      { columns && rows && (
        <DataGrid
          sx={{ height: '100%' }}
          rows={rows}
          columns={columns}
          onRowClick={({ row }) => onRowClick(row.id)}
          components={{ Toolbar }}
          componentsProps={{
            toolbar: {
              local,
              onAddClick,
              onTypesClick,
              onPartiesClick,
            },
          }}
        />
      )}
    </Paper>
  );
}

PresidentsTable.propTypes = {
  parties: PropTypes.arrayOf(PropTypes.shape({})),
  presidents: PropTypes.arrayOf(PropTypes.shape({})),
  onRowClick: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
  onTypesClick: PropTypes.func.isRequired,
  onPartiesClick: PropTypes.func.isRequired,
};

PresidentsTable.defaultProps = {
  parties: undefined,
  presidents: undefined,
};
